import React, {ReactNode} from "react";
import ReviewStationType from "@Pages/reviews/types/ReviewStation.type";

interface ReviewStationProps {
    id: string,
    stationHandler: (station: ReviewStationType) => void,
    activeStationHandler: (stations: string[]) => void,
    filteredStations: string[]
    children: ReactNode,
}

function ReviewStation({id, name, stationHandler, activeStationHandler, filteredStations, children}: ReviewStationProps) {
    const handleStationClick = () => {
        const station = filteredStations.find(stationId => stationId == id)
        //add station to filters only if it is not already in filters
        if(!station){
            stationHandler({id: id, name: name});
            activeStationHandler([...filteredStations, id]);
        }
    }

    return (
        <button
            type="button"
            className="gb--emphasize-info"
            onClick={handleStationClick}
        >
            {children}
        </button>
    )
}

export default ReviewStation